import { createApp } from 'vue'
import App from './App.vue'
import router from "./router";
import BootstrapVue3 from 'bootstrap-vue-3';
import VueApexCharts from "vue3-apexcharts";
import vClickOutside from "click-outside-vue3";
import { registerScrollSpy } from 'vue3-scroll-spy';
import Maska from 'maska'
import {i18n} from "./helpers/i18n.js" 
import 'sweetalert2/dist/sweetalert2.min.css';
import '@vueform/slider/themes/default.css'; 
import "../src/design/app.scss";
import axios from 'axios'
import VueCookies from 'vue-cookies'
import VueCryptojs from 'vue-cryptojs'
import Toaster from '@meforma/vue-toaster'; 
import VueFormWizard from "vue3-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";  
import CKEditor from '@ckeditor/ckeditor5-vue';
import ResizeTextarea from 'resize-textarea-vue3'
import { VueDraggableNext } from 'vue-draggable-next';
 

fetch(window.location.protocol+"//"+window.location.host+"/assets/config.json")
.then(response => response.json())
  .then(async (config) => {
console.log("config",config)
localStorage.setItem("config", JSON.stringify(config)) 
    const { default: store } = await import('./state/store.js');
axios.defaults.baseURL = config.API_URL
axios.defaults.headers.common = { 'Authorization': 'Bearer '+store.getters["auth/JWToken"] }
 
let app = createApp(App)     

app.component('draggable', VueDraggableNext); 

  app.provide('$config', config) 
  app.use(Toaster,{ position: "top-right", duration:2000})
  app.use(VueFormWizard) 
  app.use(CKEditor)
  app.use(VueCookies)
  app.use(VueCryptojs)
  app.use(store)
  app.use(router)
  app.use(require('vue-chartist'))
  app.use(BootstrapVue3)
  app.use(VueApexCharts)
  app.use(vClickOutside)
  app.use(i18n)
  app.use(registerScrollSpy)
  app.use(Maska)
  app.use(ResizeTextarea) 
  app.mount('#app')  
}) 